import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import { getNavigation } from '@plone/volto/actions/navigation/navigation';
import { getBaseUrl } from '@plone/volto/helpers/Url/Url';
import { hasApiExpander } from '@plone/volto/helpers/Utils/Utils';
import config from '@plone/volto/registry';
import { Menu } from 'semantic-ui-react';

import NavItems from '@plone/volto/components/theme/Navigation/NavItems';
const messages = defineMessages({
  menu_label: {
    id: 'Main navigation menu',
    defaultMessage: 'Main navigation menu',
  },
});

const Navigation = (props) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const { pathname } = props;
  const token = useSelector((state) => state.userSession.token, shallowEqual);
  const items = useSelector((state) => state.navigation.items, shallowEqual);
  const lang = useSelector((state) => state.intl.locale);

  useEffect(() => {
    const { settings } = config;
    if (!hasApiExpander('navigation', getBaseUrl(pathname))) {
      dispatch(getNavigation(getBaseUrl(pathname), settings.navDepth));
    }
  }, [pathname, token, dispatch]);

  return (
    <nav
      className="site-navigation desktop"
      id="navigation-desktop"
      aria-label={intl.formatMessage(messages.menu_label)}
    >
      <Menu secondary className="desktop-nav">
        <NavItems items={items} lang={lang} />
      </Menu>
    </nav>
  );
};

Navigation.propTypes = {
  pathname: PropTypes.string,
};

export default Navigation;
